/**
 * Consultancy.tsx — V4-6-2 / V4-6-6.
 *
 * /consultancy public page. Fractional-CISO operator console overview.
 * Points authenticated users to /o/:orgSlug/dashboard for the roll-up.
 *
 * Public, no auth.
 */

import { useNavigate } from 'react-router-dom';
import { Button, Card, PageHeader } from '@aigovops/design-system';

export function Consultancy() {
  const navigate = useNavigate();
  return (
    <main style={{
      maxWidth: 960,
      margin: '0 auto',
      padding: 'var(--space-6) var(--space-4)',
      fontFamily: 'var(--font-ui)',
    }}>
      <PageHeader
        title="Fractional CISO console"
        subtitle="Manage multiple client workspaces from one operator view."
      />

      <div style={{
        display: 'grid',
        gap: 'var(--space-4)',
        marginTop: 'var(--space-4)',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
      }}>
        <Card>
          <div style={{ padding: 'var(--space-4)', display: 'grid', gap: 'var(--space-2)' }}>
            <h3 style={{ margin: 0, fontSize: 'var(--font-size-md)', fontWeight: 600, color: 'var(--text)' }}>
              Cross-client oversight
            </h3>
            <p style={{ margin: 0, fontSize: 'var(--font-size-2xs)', color: 'var(--text-muted)', lineHeight: 1.5 }}>
              Oversight status per client workspace. Systems at each stage, releases due,
              review requests open — one dashboard across your portfolio.
            </p>
          </div>
        </Card>

        <Card>
          <div style={{ padding: 'var(--space-4)', display: 'grid', gap: 'var(--space-2)' }}>
            <h3 style={{ margin: 0, fontSize: 'var(--font-size-md)', fontWeight: 600, color: 'var(--text)' }}>
              Shared register read
            </h3>
            <p style={{ margin: 0, fontSize: 'var(--font-size-2xs)', color: 'var(--text-muted)', lineHeight: 1.5 }}>
              Refer a client with an invitation that grants shared register
              read access. Each client keeps their own workspace — you see
              the roll-up.
            </p>
          </div>
        </Card>

        <Card>
          <div style={{ padding: 'var(--space-4)', display: 'grid', gap: 'var(--space-2)' }}>
            <h3 style={{ margin: 0, fontSize: 'var(--font-size-md)', fontWeight: 600, color: 'var(--text)' }}>
              Portfolio pricing
            </h3>
            <p style={{ margin: 0, fontSize: 'var(--font-size-2xs)', color: 'var(--text-muted)', lineHeight: 1.5 }}>
              One seat across client workspaces. The org-admin roll-up
              enforces read-only — you advise, you don't write.
            </p>
          </div>
        </Card>
      </div>

      <div style={{ marginTop: 'var(--space-5)', display: 'flex', gap: 'var(--space-3)' }}>
        <Button onClick={() => navigate('/signup')}>Get started</Button>
        <Button variant="secondary" onClick={() => navigate('/pricing')}>See pricing</Button>
      </div>
    </main>
  );
}
